import Vue from "vue"
import { DateTime } from 'luxon'
import flags from "@/assets/countries-flags.json"

export function escapeRegExp() {
    return s => s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");    
}

export function getNoLines(str) {
	return str.split(/\r\n|\r|\n/).length;
}

export function getParagraphLines(width) {
    // 185 - average 180 -> 190 - max width from A4 doc size 210mm - 10mm margin left and right
    return Math.floor(width / 185);
}

export function getFlag(country) {
    if (country && country != 'ro') {
        const flagCountry = flags[country.toUpperCase()]
        return flagCountry.emoji
    } else {
        return
    }
}

export function replaceSpecialCh(str) {
    return str
        .replace(/ș|Ș/g, "s")
        .replace(/ț|Ț/g, "t")
        .replace(/î|Î/g, "i")
        .replace(/ă|â|Â|Ă/g, "a");
}

export function formatPhoneNo(str) {
    if (str.charAt(0) == "+" || str.charAt(0) == "(") {
        return str;
    } else {
        return "+4" + str;
    }
}

export function getFormattedAddressFromAnaf(addressObj) {
    const streetAddon = addressObj.sdetalii_Adresa ? addressObj.sdetalii_Adresa : "";
    return `${addressObj.sdenumire_Strada} ${addressObj.snumar_Strada}${streetAddon ? ', ' + streetAddon : ''}`;
  }

export function normalizeCountyName(countyName) {
    return countyName.toLowerCase()
        .replace(/ș/g, 's')
        .replace(/ş/g, 's')
        .replace(/ț/g, 't')
        .replace(/ţ/g, 't')
        .replace(/ă/g, 'a')
        .replace(/â/g, 'a')
        .replace(/î/g, 'i')
        .replace(/[^a-z\s-]/g, '')
        .split(/([ -])/g)
        .map(part => /^[a-z]/.test(part) ? part.charAt(0).toUpperCase() + part.slice(1) : part)
        .join('');
}

export function onlyUnique(value, index, arr) {
	return arr.indexOf(value) === index;
}

// tarile in care lucram, aceeasi lista ca la ofertele de productie
export const companyCountries = [
    { code: "ro", name: "Romania" },
    { code: "at", name: "Austria" },
    { code: "de", name: "Germania" },
    { code: "fr", name: "Franta" },
    { code: "hu", name: "Ungaria" },
]

// codul fiscal si numarul de inregistrare difera de la o tara la alta
const companyFields = {
    ro: {
        vatLabel: "CUI", vatHint: "RO123456 sau 123456", vatFormat: /^(RO)?[0-9]{2,10}$/i,
        regLabel: "Reg Com", regHint: "J12/345/2020"
    },
    at: {
        vatLabel: "UID (TVA)", vatHint: "ATU12345678", vatFormat: /^(AT)?U[0-9]{8}$/i,
        regLabel: "Firmenbuchnummer", regHint: "FN 123456a"
    },
    de: {
        vatLabel: "USt-IdNr. (TVA)", vatHint: "DE123456789", vatFormat: /^(DE)?[0-9]{9}$/i,
        regLabel: "Handelsregister", regHint: "HRB 12345"
    },
    fr: {
        vatLabel: "No TVA intracom.", vatHint: "FR12345678901", vatFormat: /^(FR)?[0-9A-Z]{2}[0-9]{9}$/i,
        regLabel: "SIREN / RCS", regHint: "123456789"
    },
    hu: {
        vatLabel: "Kozossegi adoszam (TVA)", vatHint: "HU12345678", vatFormat: /^(HU)?[0-9]{8}$/i,
        regLabel: "Cegjegyzekszam", regHint: "01-09-123456"
    },
}

export function getCompanyFields(country) {
    return companyFields[country] || companyFields.ro
}

export function getCountryName(country) {
    const item = companyCountries.find(item => item.code == country)
    return item ? item.name : country
}

export function normalizeVatNo(vatNo, country) {
    if (!vatNo) {
        return vatNo
    }
    const cleaned = vatNo.replace(/[\s.-]/g, "").toUpperCase()
    // pe RO prefixul il pune ANAF, doar daca firma e platitoare de TVA
    if (!country || country == "ro") {
        return cleaned
    }
    const prefix = country.toUpperCase()
    return cleaned.startsWith(prefix) ? cleaned : prefix + cleaned
}

export function containsObjectValue(obj, list, item) {
    let i;
    for (i = 0; i < list.length; i++) {
        if (list[i][item] === obj[item]) {
            return true;
        }
    }
    return false;
}

export function isObjEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}

export function vatRateOnDate(isoDate) {
    const date = DateTime.fromISO(String(isoDate));
    const vatChangeDate = DateTime.local(2025, 8);
    
    if (date.endOf("day") <= vatChangeDate.startOf("day")) {
        return Vue.prototype.$oldVatRate
    } else {
        return Vue.prototype.$vatRate
    }

}

/**
 * The fence part of an offer, contract or work order, with VAT.
 *
 * `val_fara_tvaG` is not stored the same way for every record. The old per-model prices included
 * VAT, so the figure carried it despite the column name; the base prices quoting replaced them
 * are net. `prices_net` on the row says which, and every total that adds this to the "alte" rows
 * or to service fees has to level them first.
 *
 * @param record   anything holding val_fara_tvaG and prices_net
 * @param isoDate  the date whose VAT rate applies; the record's own `data` by default
 */
export function fenceValueWithVat(record, isoDate) {
    if (!record) return 0;

    const value = Number(record.val_fara_tvaG) || 0;

    return +record.prices_net ? value * vatRateAddOnDate(isoDate || record.data) : value;
}

/**
 * The "alte materiale/produse" part of a fence offer or contract, with VAT.
 *
 * `val_fara_tvaA` is net - the accessories catalogue is priced net and a hand-typed line is
 * entered net, and the rows written before that was true were converted by
 * migrations/2026_09_14_convert_alte_materiale_to_net.php. So there is one rule and no flag: add
 * VAT once, here, wherever the figure joins a total that carries it.
 *
 * Fence offers only. The same column on a works offer is net as well, but nothing adds VAT to it -
 * those screens quote net throughout.
 *
 * @param record   anything holding val_fara_tvaA
 * @param isoDate  the date whose VAT rate applies; the record's own `data` by default
 */
export function otherValueWithVat(record, isoDate) {
    if (!record) return 0;

    return (Number(record.val_fara_tvaA) || 0) * vatRateAddOnDate(isoDate || record.data);
}

export function vatRateAddOnDate(isoDate) {
    const date = DateTime.fromISO(String(isoDate));
    const vatChangeDate = DateTime.local(2025, 8);
    
    if (date.endOf("day") <= vatChangeDate.startOf("day")) {
        return Vue.prototype.$oldVatRateAdd
    } else {
        return Vue.prototype.$vatRateAdd
    }

}

export function vatRateStringOnDate(isoDate) {
    const date = DateTime.fromISO(String(isoDate));
    const vatChangeDate = DateTime.local(2025, 8);
    
    if (date.endOf("day") <= vatChangeDate.startOf("day")) {
        return '19%'
    } else {
        return '21%'
    }

}

export function dimTextString(produs) {
    let str = "";
    if (produs.denumire.value == "Profil U") {
        str = produs.dimH;
    } else {
        str = produs.dimL;
    }
    if (produs.denumire.value == "Profil U") {
        str += " x " + produs.dimL;
    }
    if (produs.dimH) {
        str += " x " + produs.dimH;
    }
    if (produs.dimG) {
        str += " x " + produs.dimG;
    }
    if (str == null || str == "") {
        return "";
    } else {
        if (!produs.dimH && !produs.dimG) {
            str = "D " + str;
        }
        return str + " mm";
    }
}

export function daysText(valid) {
    if (isNaN(valid) == false) {
        if (valid == 1) {
            return " 1 zi";
        } else {
            return ` ${valid} zile`;
        }
    } else {
        return valid;
    }
}

// Export (EU) agents - Users.agent_market 'export', other than admins and superusers - work only
// on EU documents, so they see only EU contracts.
export function isExportOnly(user) {
  return !!user && user.agent_market === "export" && !["admin", "superuser"].includes(user.rol);
}
